export default function Footer() {
  return (
    <p>© {new Date().getFullYear()} Rwanda Environment Management Authority</p>
  )
}
